import { Component, EventEmitter, OnInit, Output } from '@angular/core';

import { BytelTagService } from '@base/services/bytel-tag.service';

import { PartnerProduct } from '@catalog/products/interface/phone';

import { MobileRecoveryService } from '@app/modules/mobile-recovery/mobile-recovery.service';
import {
    CritereRepriseParProduit,
    CriteresRepriseProduit,
    DevisRepriseMobileOut,
    DevisRepriseMoobileOutCritereReprise,
    ReponseCriteres,
} from '@app/modules/mobile-recovery/modal-recovery/interface/modal-recovery-model';

import { Subject, forkJoin, takeUntil } from 'rxjs';

import { RecoverySteps } from '../modal-recovery.component';

@Component({
    selector: 'btl-modal-recovery-listing',
    templateUrl: './modal-recovery-listing.component.html',
    styleUrls: ['./modal-recovery-listing.component.scss'],
})
export class ModalRecoveryListingComponent implements OnInit {
    @Output() goToNextStep = new EventEmitter<void>();
    @Output() goToPreviousStep = new EventEmitter<void>();
    public selectedPhone: PartnerProduct;
    public configurators: CriteresRepriseProduit[] = null;
    public devis: DevisRepriseMobileOut;
    public formMissingResponses: CriteresRepriseProduit[];
    private _scavenger = new Subject();
    public isLoading: boolean = false;
    public formIncomplete: boolean = true;

    constructor(private mobileRecoveryService: MobileRecoveryService, private tagService: BytelTagService) {}

    public ngOnInit(): void {
        this.selectedPhone = this.mobileRecoveryService.getItem('recoverySelectedPhone');
        this.devis = this.mobileRecoveryService.getDevis(this.selectedPhone.id) || { criteresReprise: [] };

        this.mobileRecoveryService
            .getProduitsPartenaireCriteres(this.selectedPhone.id)
            .pipe(takeUntil(this._scavenger))
            .subscribe((criteresRepriseProduit: CritereRepriseParProduit) => {
                this.mobileRecoveryService.initStorageListing(criteresRepriseProduit);
                this.configurators = criteresRepriseProduit.criteresRepriseProduit;
                this.configurators.forEach((configurator: CriteresRepriseProduit) => {
                    configurator.optionSelected = this.devis.criteresReprise.length
                        ? this.devis.criteresReprise.find((dataCritere) => dataCritere.id === configurator.id).reponse
                              .value
                        : null;
                    configurator.descriptionSelected = configurator.optionSelected
                        ? configurator.reponses.find(
                              (reponseCriteres: ReponseCriteres) =>
                                  reponseCriteres.libelle === configurator.optionSelected,
                          ).description
                        : configurator.reponses[0].description;
                    configurator.options = [];
                    configurator.reponses.forEach((response) => {
                        configurator.options.push(response.libelle);
                    });
                });
            });

        this.sendTag();
    }

    public ngOnDestroy(): void {
        // Used for scavenger observable unsubscriptions
        this._scavenger.next(null);
        this._scavenger.complete();
    }

    public selectConfigurator(configuratorForm: CriteresRepriseProduit, value: string): void {
        this.mobileRecoveryService.setItem(
            this.mobileRecoveryService.MOBILE_RECOVERY_STEP_STORAGE_KEY,
            RecoverySteps.Listing,
        );
        this.configurators.forEach((configurator: CriteresRepriseProduit) => {
            if (configurator.id === configuratorForm.id) {
                const reponse = configurator.reponses.find((response) => response.libelle === value);
                this.devis.criteresReprise = this.devis.criteresReprise.filter(
                    (dataCritere) => dataCritere.id !== configurator.id,
                );
                this.devis.criteresReprise.push({
                    id: configurator.id,
                    question: configurator.libelle,
                    reponse: { id: reponse.id, value: reponse.libelle },
                });
                this.devis.criteresReprise.sort((a, b) => a.id.localeCompare(b.id));
                configurator.descriptionSelected = reponse.description;
                configurator.optionSelected = reponse.libelle;
            }
        });

        this.formMissingResponses = JSON.parse(JSON.stringify(this.configurators));
        this.devis.criteresReprise.forEach((criteresReprise: DevisRepriseMoobileOutCritereReprise) => {
            this.formMissingResponses = this.formMissingResponses.filter(
                (dataCritere) => dataCritere.id !== criteresReprise.id,
            );
        });

        switch (this.formMissingResponses.length) {
            case 0:
                this.formIncomplete = false;
                this.callProduitsPartenaireDevis();
                break;

            case 1:
                this.predictProduitsPartenaireDevis();
                break;
        }
    }

    /**
     * appel le service pour avoir le devis du téléphone
     *
     * @param nextStep
     */
    public callProduitsPartenaireDevis(nextStep: boolean = false) {
        this.mobileRecoveryService
            .getProduitsPartenaireDevis(this.selectedPhone.id, this.devis)
            .pipe(takeUntil(this._scavenger))
            .subscribe((data) => {
                if (nextStep) {
                    this.isLoading = false;
                    this.goToNextStep.emit();
                }
            });
        this.mobileRecoveryService.setDevis(this.selectedPhone.id, this.devis);
    }

    /**
     *
     */
    public predictProduitsPartenaireDevis(): void {
        const listDevis = [];
        for (let response of this.formMissingResponses[0].reponses) {
            const devisTmp = JSON.parse(JSON.stringify(this.devis));

            devisTmp.criteresReprise.push({
                id: this.formMissingResponses[0].id,
                reponse: {
                    id: response.id,
                    value: response.libelle,
                },
            });
            devisTmp.criteresReprise.sort((a, b) => a.id.localeCompare(b.id));

            listDevis.push(this.mobileRecoveryService.getProduitsPartenaireDevis(this.selectedPhone.id, devisTmp));
        }
        forkJoin(listDevis).pipe(takeUntil(this._scavenger)).subscribe();
    }

    public next(): void {
        if (this.formMissingResponses.length === 0) {
            this.isLoading = true;
            this.callProduitsPartenaireDevis(true);
        }
    }

    public previous(): void {
        this.goToPreviousStep.emit();
    }

    public sendTag() {
        this.tagService.send({
            page: 'E2_Infos_etat_mobile',
            pageCategorie: 'Formulaire',
        });
    }
}
